import * as React from "react"

import {DateRangeBlock} from "@components";
import {DATE_PERIODS} from "@constants"
import {evolutionSkuCurrentPeriod} from "../../../@signals";
import {rangeDatesPricingDiscountSkuEvolution} from "./Ranges";


export default function PricingSkuEvolutionDatePeriodSelect({dateRange, onChange}) {

    return <DateRangeBlock
        currentPeriodLabel={evolutionSkuCurrentPeriod.value}
        maxDays={90}
        value={dateRange}
        ranges={rangeDatesPricingDiscountSkuEvolution}
        onChange={onChange}
        onOk = { () => evolutionSkuCurrentPeriod.value = DATE_PERIODS.CUSTOM }
    />
}